export default {"src":"/_next/static/media/stars.4ff28237.svg","height":21,"width":121,"blurWidth":0,"blurHeight":0};